import { createLucideIcon } from "lucide-react";

export const ArrowRightCircle = createLucideIcon(
    "ArrowRightCircle",
    [
        [
            "path",
            {
                d: "M10.5 16L13.275 12.3C13.4083 12.1222 13.4083 11.8778 13.275 11.7L10.5 8",
                key: "5gjowc",
            },
        ],
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                key: "1mglay",
                r: "10",
            },
        ],
    ],
);
